import { render, staticRenderFns } from "./EventsTopay.vue?vue&type=template&id=4c422ac1"
import script from "./EventsTopay.vue?vue&type=script&lang=js"
export * from "./EventsTopay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports